module.exports = __webpack_public_path__ + "static/media/mapimage.2ccc012e.jpg";